import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { PerformanceData } from 'pages/hvareporting/debtcollection/CampaignPerformanceReport';
import EvolutionSeriesChart from 'components/charts/EvolutionSeriesChart3';
import EvolutionSeriesChart2 from 'components/charts/EvolutionSeriesChart4';

interface AgreementsSectionProps {
  data: PerformanceData[];
}

const AgreementsSection: React.FC<AgreementsSectionProps> = ({ data }) => {
  return (
    <Row className="gy-3 mb-2 justify-content-between bg-body-emphasis">
      <Col xs={12}>
        <h5>Calling effectiveness</h5>
        <div className="border rounded p-3">
          <EvolutionSeriesChart data={data} />
          <p className="pt-4"></p>
          <EvolutionSeriesChart2 data={data} />
        </div>
      </Col>
    </Row>
  );
};

export { AgreementsSection };
